import React from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";

function PdfTable({datas}) {
  const downloadPDFFile = () => {

    const headers = [["SETTLEMENT", "GROSS AMOUNT","COLLECTIVELY FEE","TRANSFER FEE","TYPE","NET AMOUNT","STATUS","DATE"]];


    let cleanArray = [];
    for (const i of datas.result.records) {
        cleanArray.push(i)
    }

    const data = 
        cleanArray.map(transactionHistory =>{
        return [
                    String(transactionHistory.settlementShortName), 
                    "$"+ String(transactionHistory.priceBreakupDto.totalAmount.toFixed(
                    2)),
                    "$"+ String(transactionHistory.priceBreakupDto.collectivelyCommissionAmount.toFixed(
                      2
                    )),
                    "$"+  String(transactionHistory.priceBreakupDto.transferFee.toFixed(
                      2
                    )),
                    String(transactionHistory.transferMode) ,
                    "$"+ String(transactionHistory.priceBreakupDto.userAmount.toFixed(
                      2
                    )),
                    "COMPLETED" ,
                    String(transactionHistory.amountTransferredDate)
                  ]
        });

      

    const doc = new jsPDF();

    const finalData2 = {
        head: headers,
        body:data,
    }
    doc.autoTable(finalData2);
    doc.save("report.pdf");
  };
  
  return (
    <span >
      <button name="download" onClick={downloadPDFFile} style={{border:"none",outline:"none",background:"none"}}>
        PDF
      </button>
    </span>
  );
}

export default PdfTable;
